import { doGraphqlRequest } from 'ducks/requests'
import graphql from '../api'
import * as types from '../types'
import { draftOrderPartial } from './partials'

const draftOrderUpdateMutation = `
  mutation ShopifyDraftOrderUpdate(
    $id: ID!,
    $input: DraftOrderInput!
  ) {
    draftOrderUpdate(id: $id, input: $input) {
      userErrors {
        message
        field
      }

      draftOrder {
        ${draftOrderPartial}
      }
    }
  }
`

const doDraftOrderUpdate = (
  integrationId,
  draftOrderId,
  input = {}
) => dispatch => {
  const variables = {
    id: draftOrderId,
    input: { ...input },
  }

  return dispatch(
    doGraphqlRequest(
      types.DRAFT_ORDER_UPDATE_REQUEST,
      draftOrderUpdateMutation,
      variables,
      {
        graphqlFunc: graphql(integrationId),
      }
    )
  )
}

export default doDraftOrderUpdate
